import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
} from '@mui/material';

import { getColorForComponentWithWorkingChanges } from '../../../capacityColors';
import { RootState } from '../../../store';
import { resetWorkingChangesForActiveComponentDesign, setActiveAnalysisSet } from '../../../store/actions/appActions';
import { getAnalysisHistoryForActiveComponentDesign } from '../../../store/selectors/getAnalysisHistoryForActiveComponentDesignSelector';
import { formatTimestampForAnalysisHistoryRecord } from './AnalysisHistoryRecordStatement';

interface OwnProps {
  active: boolean;
}

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;

type Props = OwnProps & StateProps & DispatchProps;

class WorkingChangesSubPanel extends React.Component<Props> {
  select = () => {
    if (!this.props.locked) {
      this.props.restoreWorkingChanges();
    }
  };

  render() {
    return (
      <ListItemButton selected={this.props.active} onClick={this.select}>
        <ListItemIcon>
          <EditIcon />
        </ListItemIcon>
        <ListItemText
          primary={<span style={{ color: getColorForComponentWithWorkingChanges() }}>Unanalyzed Changes</span>}
          secondary={
            this.props.lastUpdatedTimestamp
              ? formatTimestampForAnalysisHistoryRecord(this.props.lastUpdatedTimestamp)
              : undefined
          }
        />

        <ListItemSecondaryAction>
          <Tooltip disableInteractive placement="right" title="Discard changes">
            <span>
              <IconButton
                disabled={!this.props.hasHistory}
                onClick={this.props.resetWorkingChangesForActiveComponentDesign}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          </Tooltip>
        </ListItemSecondaryAction>
      </ListItemButton>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  locked: state.analysisSets.loadingAnalysisSet,
  lastUpdatedTimestamp: state.componentDesignTimestamps[state.selections.activeComponentDesignGuid!]?.lastUpdated,
  hasHistory: !!getAnalysisHistoryForActiveComponentDesign(state)?.length,
});

const actionCreators = {
  resetWorkingChangesForActiveComponentDesign,
  restoreWorkingChanges: () => setActiveAnalysisSet(undefined),
};

export default connect(mapStateToProps, actionCreators)(WorkingChangesSubPanel);
